import * as API_Login from '@/api/login'
import Storage from '@/utils/storage'
import jwt_decode from 'jwt-decode'

// state
const _user = Storage.getItem('points_admin_user')
export const state = {
  user: _user ? JSON.parse(_user) : ''
}

// mutations
export const mutations = {
  /**
   * 设置用户信息
   * @param state
   * @param user
   * @constructor
   */
  SET_USER: (state, user) => {
    state.user = user
    Storage.setItem('admin_id',user.admin_id)
    Storage.setItem('admin_name',user.name)
    // Storage.setItem('points_admin_uid', user.uid)
  },
  /**
   * 设置访问令牌
   * @param state
   * @param token
   * @constructor
   */
  SET_TOKEN: (state, token) => {
    const expires = new Date(new Date() * 1 + 3600000 * 6) // 6小时过期
    Storage.setItem('jession_token', token, { expires })
  },
   /**
   * 设置访问菜单
   * @param state
   * @param token
   * @constructor
   */
    SET_MENU: (state, menus) => {
      // menus= menus.filter(ele=>ele.type===1).map(ele=>ele.authRegular)
      let role_menus = menus.filter(ele=>ele.type===1).map(item=>item.authRegular)
      let role_power = menus.filter(ele=>ele.type===2).map(item=>item.authRegular)
      // Storage.setItem('role_menus', JSON.stringify(role_menus))
      // Storage.setItem('role_power', JSON.stringify(role_power))
      localStorage.setItem('role_menus', JSON.stringify(role_menus))
      localStorage.setItem('role_power', JSON.stringify(role_power))
    },
  /**
   * 移除用户信息
   * @param state
   * @constructor
   */
  REMOVE_MENU: (state) => {
    // Storage.removeItem('role_menus')
    // Storage.removeItem('role_power')
    localStorage.removeItem('role_menus')
    localStorage.removeItem('role_power')
  },
  /**
   * 移除访问令牌
   * @param state
   * @constructor
   */
  REMOVE_NEW_TOKEN: (state) => {
    Storage.removeItem('jession_token')
  }
}

// actions
export const actions = {
  /**
   * 用户名登录
   * @param commit
   * @param params
   * @returns {Promise<any>}
   */
  loginAction({ commit , dispatch }, params) {
    return new Promise((resolve, reject) => {
      API_Login.login(params).then(response => {
        if(response.msg){
          alert(response.msg)
          return resolve()
        }
        if(response.cookie === null && !params.isold){
          params.isold = true
          dispatch('loginAction',params)
          return
        }
        commit('SET_TOKEN', response.cookie)
        commit('SET_MENU',response.menus)
        commit('SET_USER',response.user_info)
        resolve()
        }).catch(reject)
    })
  },
  /**
   * 登出
   * @param dispatch
   * @param state
   * @returns {Promise<any>}
   */
  logoutAction({ dispatch }) {
    dispatch('fedLogoutAction')
  },
  /**
   * 前端退出
   * @param commit
   */
  fedLogoutAction: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit('REMOVE_NEW_TOKEN')
      // commit('REMOVE_MENU')
      API_Login.logout().then(response => {
        resolve()
      }).catch(reject)
    })
    
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js